var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 65,
    viewBox: "0 0 63 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_203_1367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0601 37.168L40.8162 15.1453C38.7927 8.61844 42.7587 7.4687 43.6597 7.36767C46.1341 7.09025 47.0476 10.5151 47.0963 12.0449C50.2641 12.9572 55.471 15.8056 51.1661 19.3072C49.8734 20.3084 46.5113 19.8359 46.1043 19.8262L22.7546 42.3544C23.4728 43.1419 24.1724 47.9779 21.2242 50.1542C16.4541 53.6756 16.1087 45.7136 14.9256 44.6918C3.2939 40.6978 14.1005 36.0276 18.0601 37.168Z",
    fill: "#8B2635",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0601 37.168L40.8162 15.1453C38.7927 8.61844 42.7587 7.4687 43.6597 7.36767C46.1341 7.09025 47.0476 10.5151 47.0963 12.0449C50.2641 12.9572 55.471 15.8056 51.1661 19.3072C49.8734 20.3084 46.5113 19.8359 46.1043 19.8262L22.7546 42.3544C23.4728 43.1419 24.1724 47.9779 21.2242 50.1542C16.4541 53.6756 16.1087 45.7136 14.9256 44.6918C3.2939 40.6978 14.1005 36.0276 18.0601 37.168Z",
    stroke: "#44000A",
    strokeWidth: 4.50549,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_203_1367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1918 37.168L21.4357 15.1453C23.4592 8.61844 19.4933 7.4687 18.5922 7.36767C16.1178 7.09025 15.2044 10.5151 15.1557 12.0449C11.9878 12.9572 6.78095 15.8056 11.0859 19.3072C12.3786 20.3084 15.7406 19.8359 16.1477 19.8262L39.4974 42.3544C38.7792 43.1419 38.0796 47.9779 41.0277 50.1542C45.7979 53.6756 46.1433 45.7136 47.3264 44.6918C58.9581 40.6978 48.1515 36.0276 44.1918 37.168Z",
    fill: "#8B2635",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1918 37.168L21.4357 15.1453C23.4592 8.61844 19.4933 7.4687 18.5922 7.36767C16.1178 7.09025 15.2044 10.5151 15.1557 12.0449C11.9878 12.9572 6.78095 15.8056 11.0859 19.3072C12.3786 20.3084 15.7406 19.8359 16.1477 19.8262L39.4974 42.3544C38.7792 43.1419 38.0796 47.9779 41.0277 50.1542C45.7979 53.6756 46.1433 45.7136 47.3264 44.6918C58.9581 40.6978 48.1515 36.0276 44.1918 37.168Z",
    stroke: "#44000A",
    strokeWidth: 4.50549,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_203_1367",
    x: 0.235547,
    y: 1.89741,
    width: 62.0172,
    height: 62.6053,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.59 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_203_1367"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_203_1367",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_203_1367",
    x: -0.000781059,
    y: 1.89741,
    width: 62.0172,
    height: 62.6053,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.59 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_203_1367"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_203_1367",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup6);
export default __webpack_public_path__ + "static/media/Group 6.9cc995cf3a9d8a7df4c02548adeedd34.svg";
export { ForwardRef as ReactComponent };